// AUTO GENERATED FILE - Changes WILL be lost.
// ru - used as 'ru' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Игровой купон",
  "product.last60-row-single": "НБА Последние 60 одиночных матчей",
  "product.sb-english-single": "Английские футбольные ставки на один матч",
  "product.sb-italian-single": "Итальянские футбольные ставки на один матч",
  "product.sb-greek-single": "Греческий Soccerbet Единый матч",
  "product.sb-english-league": "Английская футбольная лига",
  "product.sb-italian-league": "Итальянская лига футбола",
  "product.sb-greek-league": "Греческая лига Soccerbet",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Сделать ставку",
  "betslip.clear": "Очистить все",
  "betslip.clearResult": "Очистить",
  "betslip.noSelections": "Выберите события для размещения ставки",
  "betslip.notLoggedIn": "Войдите чтобы сделать ставку",
  "betslip.refresh": "Обновить",
  "betslip.totalStake": "Сумма",
  "betslip.noHistoryData": "Нет информации по ставкам",
  "betslip.openBets": "Открытые ставки",
  "betslip.betHistory": "История ставок",
  "betslip.betHistoryWon": "Выигрыш",
  "betslip.betHistoryLost": "Проигрыш",
  "loading.loading": "Загрузка",
  "loading.account": "Загрузка аккаунта",
  "loading.league": "Загрузка лиги",
  "loading.gameweeks": "Загрузка игровой недели",
  "loading.markets": "Загрузка событий",
  "loading.bethistory": "Загрузка истории ставок",
  "login.loginRequired": "Требуется логин",
  "login.loginToBet": "Пожалуйста, войдите чтобы сделать ставку",
  "navigation.back": "Вернуться",
  "navigation.close": "Закрыть",
  "video.liveStreamAvailable": "Live трансляция доступна",
  "video.logInToWatch": "Пожалуйста, авторизуйтесь для просмотра",
  "error.error": "Ошибка",
  "error.404": "Страница не найдена",
  "error.gameLaunchFailed": "Невозможно запустить игру",
  "error.unknownErrorCode": "Неизвестная ошибка: {code}",
  "error.minUnitStakeLimitExceeded": "Минимальная ставка {limit}",
  "error.maxUnitStakeLimitExceeded": "Максимальная ставка {limit}",
  "error.minTotalStakeLimitExceeded": "Минимальная сумма ставки {limit}",
  "error.maxTotalStakeLimitExceeded": "Максимальная сумма ставки {limit}",
  "error.stakeInvalidMultiple": "Ставка должна быть кратна {multiple}",
  "error.notPlaced": "Ставка не размещена",
  "error.wagerDisallowed": "Ставка запрещена",
  "error.errorEventIsOff": "Событие началось",
  "wagerType.Singles": "Ординар",
  "wagerType.Doubles": "Двойники",
  "wagerType.Trebles": "Тройники",
  "wagerType.Accumulator": "Экспресс",
  "wagerType.Perm 4-Folds": "Система 4",
  "wagerType.Perm 5-Folds": "Система 5",
  "wagerType.Perm 6-Folds": "Система 6",
  "wagerType.Perm 7-Folds": "Система 7",
  "wagerType.Perm 8-Folds": "Система 8",
  "wagerType.Perm 9-Folds": "Система 9",
  "error.excess_bets": "Максимум {limit} одновременных ставок на листе ставок; пожалуйста, удалите ставку",
  "product.sb-turkish-league": "Турецкая лига Soccerbet",
  "error.minBetslipLimitExceeded": "Минимальная общая сумма ставки составляет {limit}",
  "error.maxBetslipLimitExceeded": "Максимальная общая сумма ставки составляет {limit}",
  "error.exceededMaxPayout": "Максимальная потенциальная выплата составляет {limit}; пожалуйста, уменьшите вашу ставку.",
  "betslip.potentialReturns": "Потенциальная прибыль",
  "betslip.taxDisclaimer": "Все ваши чистые выигрыши облагаются налогом при расчете ставки. Сумма налога будет рассчитана в зависимости от потенциального выигрыша по ставке.",
  "error.maintenanceEnabled": "В настоящее время сервер находится на техническом обслуживании",
  "error.internalError": "Внутренняя ошибка",
  "error.invalidSession": "Сессия недействительна",
  "error.accountDisabled": "Учетная запись отключена",
  "error.invalidPlayerID": "Неверный идентификатор игрока",
  "error.insufficientBalance": "Недостаточный баланс",
  "error.configError": "Ошибка конфигурации",
  "error.betPlaceFailed": "Не удалось сделать ставку",
  "error.invalidProductID": "Неверный идентификатор продукта",
  "error.playerReachedGamingLimits": "Игрок достиг лимита ответственных игр",
  "error.gameCycleDoesNotExist": "Игровой цикл не существует",
  "error.betAmountLimitExceeded": "Превышение лимита потенциального выигрыша для непроверенных игроков",
  "betslip.netStake": "Чистая ставка",
  "betslip.tax": "Налог",
  "error.badReturns": "Потенциальная прибыль ниже, чем валовая ставка",
  "betslip.taxDisclaimerPoland": "Выигрыш будет уменьшен на 10% для сумм, превышающих 2 280 злотых.",
  "error.incompatibleVersion": "Неподдерживаемая версия приложения. Пожалуйста, обновите.",
  "product.iihf-row-single": "Чемпионат мира по хоккею",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Вернуться к игроку",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "Средний RTP для этой игры составляет {limit}",
  "error.betslipContainsInvalidOptions": "В бетслипе красным цветом выделены недействительные опционы",
  "product.sb-scottish-single": "Шотландский футбол, одиночный матч",
  "product.sb-spanish-single": "Одиночный матч на испанском футболе",
  "product.sb-spanish-league": "Испанская лига футбола",
  "sb-english.team.ARS": "Арсенал",
  "sb-english.team.AST": "Астон В.",
  "sb-english.team.BHA": "Брайтон",
  "sb-english.team.BOU": "Борнмут",
  "sb-english.team.BUR": "Бернли",
  "sb-english.team.CHE": "Челси",
  "sb-english.team.CRY": "К. Пэлас",
  "sb-english.team.EVE": "Эвертон",
  "sb-english.team.LEI": "Лестер",
  "sb-english.team.LIV": "Ливерпуль",
  "sb-english.team.MNC": "Манчестер С.",
  "sb-english.team.MNU": "Манчестер Ю.",
  "sb-english.team.NEW": "Ньюкасл",
  "sb-english.team.SOU": "Саутгемптон",
  "sb-english.team.TOT": "Тоттенхэм",
  "sb-english.team.WAT": "Уотфорд",
  "sb-english.team.WHU": "Вест Хэм",
  "sb-english.team.WOL": "Вульвс",
  "sb-english.team.NOR": "Норвич",
  "sb-english.team.SHU": "Шеффилд Ю.",
  "sb-english.team.LEE": "Лидс",
  "sb-english.team.FUL": "Фуллхэм",
  "sb-english.team.WBA": "Уэст Бром",
  "sb-greek.team.AEK": "АЕК АФИНЫ",
  "sb-greek.team.APS": "АПОЛЛОН СМИРНИС",
  "sb-greek.team.ARI": "АРИС САЛОНИКИ",
  "sb-greek.team.AST": "АСТЕРАС ТРИПОЛИ",
  "sb-greek.team.ATR": "АТРОМИТОС",
  "sb-greek.team.GIA": "ПАС ДЖАННИНА",
  "sb-greek.team.LEV": "ЛЕВАДИАКОС",
  "sb-greek.team.OFI": "ОФИ",
  "sb-greek.team.OLM": "ОЛИМПИАКОС",
  "sb-greek.team.PTK": "ПАНАТИНАЙКОС",
  "sb-greek.team.PNS": "ПАНИОНИОС",
  "sb-greek.team.PAO": "ПАОК САЛОНИКА",
  "sb-greek.team.PLT": "ПЛАТАНИАС",
  "sb-greek.team.XAN": "КСАНТИ",
  "sb-italian.team.MIL": "Милан",
  "sb-italian.team.ATA": "Аталанта",
  "sb-italian.team.BOL": "Болонья",
  "sb-italian.team.BRE": "Брешия",
  "sb-italian.team.CAG": "Кальяри",
  "sb-italian.team.CHI": "Кьево",
  "sb-italian.team.FIO": "Фиорентина",
  "sb-italian.team.GEN": "Генуя",
  "sb-italian.team.INT": "Интер",
  "sb-italian.team.JUV": "Ювентус",
  "sb-italian.team.LAZ": "Лацио",
  "sb-italian.team.NAP": "Неаполь",
  "sb-italian.team.ROM": "Рома",
  "sb-italian.team.SAM": "Сампдория",
  "sb-italian.team.UDI": "Удинезе",
  "sb-italian.team.VER": "Верона",
  "nomorebets": "Прием ставок закрыт",
  "playtime": "Время игры",
  "gameId": "ID игры",
  "noGames": "В данный момент отсутствуют доступные игры. Пожалуйста, попробуйте еще раз позже.",
  "Home": "Хозяева",
  "Away": "Гости",
  "Visitor": "Посетители",
  "rules": "Правила",
  "soccerbet.gameWeek": "СЕЗОН",
  "soccerbet.noGameWeeks": "Нет доступных сезонов. Попробуйте еще раз в ближайшее время.",
  "soccerbet.league": "Таблица лиги",
  "soccerbet.table.name": "Команда",
  "soccerbet.table.won": "В",
  "soccerbet.table.drawn": "Н",
  "soccerbet.table.lost": "П",
  "soccerbet.table.points": "Очки",
  "abbr.event.Both Teams To Score": "ОЗ",
  "event.Both Teams To Score": "Обе Команды Забьют",
  "event.Over / Under": "Больше/Меньше",
  "event.Double Chance": "Двойной Результат",
  "event.Match Result": "Результат Матча",
  "event.Exact Goals": "Количество Голов",
  "event.Correct Score": "Точный Счет",
  "event.Match Result Both Score": "Результат Матча + Обе Забьют",
  "event.Result Und/Over 1.5 Total Goals": "Результат Матча + Тотал Больше/Меньше 1.5",
  "event.Result Und/Over 2.5 Total Goals": "Результат Матча + Тотал Больше/Меньше 2.5",
  "event.Under Over 1.5 Total Goals": "Тотал Больше/Меньше 1.5 голов",
  "event.Under Over 2.5 Total Goals": "Тотал Больше/Меньше 2.5 голов",
  "event.Under Over 3.5 Total Goals": "Тотал Больше/Меньше 3.5 голов",
  "event.Under Over 4.5 Total Goals": "Тотал Больше/Меньше 4.5 голов",
  "event.Total Goals 1 To 2": "Тотал от 1 до 2 голов",
  "event.Total Goals 1 To 3": "Тотал от 1 до 3 голов",
  "event.Total Goals 1 To 4": "Тотал от 1 до 4 голов",
  "event.Total Goals 2 To 3": "Тотал от 2 до 3 голов",
  "event.Total Goals 2 To 4": "Тотал от 2 до 4 голов",
  "event.Under Over 1.5 Home Goals": "Хозяева Тотал Больше/Меньше 1.5 голов",
  "event.Under Over 1.5 Away Goals": "Гости Тотал Больше/Меньше 1.5 голов",
  "event.Home Team Exact Goals": "Хозяева Количество Голов",
  "event.Away Team Exact Goals": "Гости Количество Голов",
  "event.Home Team To Score": "Хозяева поля забьют",
  "event.Away Team To Score": "Команда гостей забьет",
  "selection.Yes": "Да",
  "selection.No": "Нет",
  "selection.1+G": "П1+Да",
  "selection.1+Ng": "П1+Нет",
  "selection.X+G": "Х+Да",
  "selection.X+Ng": "Х+Нет",
  "selection.2+G": "П2+Да",
  "selection.2+Ng": "П2+Нет",
  "selection.1+Yes": "1+Да",
  "selection.1+No": "1+Нет",
  "selection.X+Yes": "Х+Да",
  "selection.X+No": "Х+Нет",
  "selection.2+Yes": "2+Да",
  "selection.2+No": "2+Нет",
  "selection.TID_ANY_GOAL_SCORED_YES": "Г",
  "selection.TID_ANY_GOAL_SCORED_NO": "Нг",
  "selection.U": "М",
  "selection.O": "Б",
  "selection.1+O": "П1+Б",
  "selection.X+O": "Х+Б",
  "selection.2+O": "П2+Б",
  "selection.1+U": "П1+М",
  "selection.X+U": "Х+М",
  "selection.2+U": "П2+М",
  "selection.TID_HOME_WIN": "П1",
  "selection.TID_AWAY_WIN": "П2",
  "selection.TID_DRAW": "Х",
  "selection.TID_HOME_WIN_OR_DRAW": "П1/Х",
  "selection.TID_DRAW_OR_AWAY_WIN": "П2/Х",
  "selection.TID_HOME_OR_AWAY_WIN": "П1/П2",
  "selection.Over": "Peste",
  "selection.Under": "Sub",
  "abbr.sb-english.team.ARS": "АРС",
  "abbr.sb-english.team.AST": "АСТ",
  "abbr.sb-english.team.BHA": "КНБК",
  "abbr.sb-english.team.BOU": "БОУ",
  "abbr.sb-english.team.BUR": "БУР",
  "abbr.sb-english.team.CHE": "ЧЕ",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "ЛЕИ",
  "abbr.sb-english.team.LIV": "ЛИВ",
  "abbr.sb-english.team.MNC": "ТНК",
  "abbr.sb-english.team.MNU": "МНУ",
  "abbr.sb-english.team.NEW": "NEW",
  "abbr.sb-english.team.SOU": "СУ",
  "abbr.sb-english.team.TOT": "ТОТ",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "ВОЛ",
  "abbr.sb-english.team.NOR": "НИ",
  "abbr.sb-english.team.SHU": "ШУ",
  "abbr.sb-english.team.LEE": "ЛИ",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "ВБА",
  "abbr.sb-italian.team.MIL": "МИЛ",
  "abbr.sb-italian.team.ATA": "АТА",
  "abbr.sb-italian.team.BOL": "Бол",
  "abbr.sb-italian.team.BRE": "БРЭ",
  "abbr.sb-italian.team.CAG": "ЦАГ",
  "abbr.sb-italian.team.CHI": "ОМС",
  "abbr.sb-italian.team.FIO": "ФИО",
  "abbr.sb-italian.team.GEN": "ОБЩ",
  "abbr.sb-italian.team.INT": "ИНТ.",
  "abbr.sb-italian.team.JUV": "ЮВ",
  "abbr.sb-italian.team.LAZ": "ЛАЗ",
  "abbr.sb-italian.team.NAP": "НПД",
  "abbr.sb-italian.team.ROM": "ПЗУ",
  "abbr.sb-italian.team.SAM": "СЭМ",
  "abbr.sb-italian.team.UDI": "УДИ",
  "abbr.sb-italian.team.VER": "ВЕР",
  "abbr.sb-greek.team.AEK": "АЕК",
  "abbr.sb-greek.team.APS": "АПС",
  "abbr.sb-greek.team.ARI": "ОРИ",
  "abbr.sb-greek.team.AST": "АСТ",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "ГИА",
  "abbr.sb-greek.team.LEV": "ЛЕВ",
  "abbr.sb-greek.team.OFI": "ОФИ",
  "abbr.sb-greek.team.OLM": "ОЛМ",
  "abbr.sb-greek.team.PTK": "ПТК",
  "abbr.sb-greek.team.PNS": "ПНС",
  "abbr.sb-greek.team.PAO": "ПАО",
  "abbr.sb-greek.team.PLT": "ПЛТ",
  "abbr.sb-greek.team.XAN": "КСАН",
  "sb-turkish.team.AKB": "АХИСАРСПОР",
  "sb-turkish.team.BES": "БЕШИКТАШ",
  "sb-turkish.team.FEN": "ФЕНЕРБАХЧЕ",
  "sb-turkish.team.GAL": "ГАЛАТАСАРАЙ",
  "sb-turkish.team.TRA": "ТРАБЗОНСПОР",
  "sb-turkish.team.ANT": "АНТАЛЬЯСПОР",
  "sb-turkish.team.GEN": "ГЕНЧЛЕРБИРЛИГИ",
  "sb-turkish.team.KAS": "КАСИМПАША",
  "sb-turkish.team.BUR": "БУРСАСПОР",
  "sb-turkish.team.KAY": "КАЙСЕРИСПОР",
  "sb-turkish.team.SIV": "СИВАССПОР",
  "sb-turkish.team.IBA": "СТАМБУЛ БАШАКШЕХИР",
  "sb-turkish.team.HAT": "ХАТАЙСПОР",
  "sb-turkish.team.ADS": "ОБЪЯВЛЕНИЕ. ДЕМИРСПОР",
  "sb-turkish.team.ALT": "АЛТАЙ",
  "sb-turkish.team.GAZ": "ГАЗИАНТЕП",
  "sb-turkish.team.GOZ": "ГЁЗТЕПЕ",
  "sb-turkish.team.KON": "КОНЬЯСПОР",
  "sb-turkish.team.CRS": "Ч. РИЗЕСПОР",
  "sb-turkish.team.ALS": "АЛАНЬЯСПОР",
  "abbr.sb-turkish.team.AKB": "АКБ",
  "abbr.sb-turkish.team.BES": "БЕС",
  "abbr.sb-turkish.team.FEN": "ФЕН",
  "abbr.sb-turkish.team.GAL": "ГАЛ",
  "abbr.sb-turkish.team.TRA": "ТРА",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "ОБЩ",
  "abbr.sb-turkish.team.KAS": "КАС",
  "abbr.sb-turkish.team.BUR": "БУР",
  "abbr.sb-turkish.team.KAY": "КЕЙ",
  "abbr.sb-turkish.team.SIV": "СИВ",
  "abbr.sb-turkish.team.IBA": "МБА",
  "abbr.sb-turkish.team.HAT": "HAT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "АЛЬТ",
  "abbr.sb-turkish.team.GAZ": "ГАЗ",
  "abbr.sb-turkish.team.GOZ": "ГОЗ",
  "abbr.sb-turkish.team.KON": "КОН",
  "abbr.sb-turkish.team.CRS": "CRS",
  "abbr.sb-turkish.team.ALS": "БАС",
  "sb-english.team.BRE": "Брентфорд",
  "abbr.sb-english.team.BRE": "БРЕ",
  "sb-english.team.NOT": "Ноттингем Ф.",
  "abbr.sb-english.team.NOT": "НЕТ",
  "sb-spanish.team.ALV": "Алавес",
  "sb-spanish.team.ATB": "Атлетик Бильбао",
  "sb-spanish.team.ATM": "Атлетико Мадрид",
  "sb-spanish.team.FCB": "Барселона",
  "sb-spanish.team.CAD": "Кадис",
  "sb-spanish.team.CLV": "Сельта Виго",
  "sb-spanish.team.ESP": "Эспаньол",
  "sb-spanish.team.GET": "Хетафе",
  "sb-spanish.team.GIR": "Жирона",
  "sb-spanish.team.GRA": "Гранада",
  "sb-spanish.team.LAP": "Лас-Пальмас",
  "sb-spanish.team.MAL": "Майорка",
  "sb-spanish.team.OSA": "Осасуна",
  "sb-spanish.team.RAY": "Райо Вальекано",
  "sb-spanish.team.BET": "Реал Бетис",
  "sb-spanish.team.MAD": "Реал Мадрид",
  "sb-spanish.team.SOC": "Реал Сойедад",
  "sb-spanish.team.SEV": "Севилья",
  "sb-spanish.team.VAL": "Валенсия",
  "sb-spanish.team.VIL": "Вильярреал",
  "abbr.sb-spanish.team.ALV": "ИВЛ",
  "abbr.sb-spanish.team.ATB": "АТБ",
  "abbr.sb-spanish.team.ATM": "ATM",
  "abbr.sb-spanish.team.FCB": "ФКБ",
  "abbr.sb-spanish.team.CAD": "САПР",
  "abbr.sb-spanish.team.CLV": "CLV",
  "abbr.sb-spanish.team.ESP": "ESP",
  "abbr.sb-spanish.team.GET": "GET",
  "abbr.sb-spanish.team.GIR": "ГИР",
  "abbr.sb-spanish.team.GRA": "ГРА",
  "abbr.sb-spanish.team.LAP": "LAP",
  "abbr.sb-spanish.team.MAL": "МАЛ",
  "abbr.sb-spanish.team.OSA": "ОСА",
  "abbr.sb-spanish.team.RAY": "РЭЙ",
  "abbr.sb-spanish.team.BET": "BET",
  "abbr.sb-spanish.team.MAD": "MAD",
  "abbr.sb-spanish.team.SOC": "СОЦ",
  "abbr.sb-spanish.team.SEV": "СЭВ",
  "abbr.sb-spanish.team.VAL": "ВАЛ",
  "abbr.sb-spanish.team.VIL": "ВИЛ",
  "sb-scottish.team.ABE": "Абердин",
  "sb-scottish.team.CEL": "кельтская",
  "sb-scottish.team.DDU": "Данди Юнайтед",
  "sb-scottish.team.HEA": "Сердца",
  "sb-scottish.team.HIB": "Хиберийский",
  "sb-scottish.team.KIL": "Килмарнок",
  "sb-scottish.team.LIV": "Ливингстон",
  "sb-scottish.team.MOT": "Мазервелл",
  "sb-scottish.team.RAN": "Рейнджерс",
  "sb-scottish.team.STJ": "Сент-Джонстон",
  "sb-scottish.team.STM": "Сент-Миррен",
  "sb-scottish.team.DDE": "Данди",
  "abbr.sb-scottish.team.ABE": "Абэ",
  "abbr.sb-scottish.team.CEL": "КЛЭ",
  "abbr.sb-scottish.team.DDU": "ДДУ",
  "abbr.sb-scottish.team.HEA": "ВЭА",
  "abbr.sb-scottish.team.HIB": "ХИБ",
  "abbr.sb-scottish.team.KIL": "КИЛ",
  "abbr.sb-scottish.team.LIV": "ЛИВ",
  "abbr.sb-scottish.team.MOT": "ТО",
  "abbr.sb-scottish.team.RAN": "РАН",
  "abbr.sb-scottish.team.STJ": "СТЖ",
  "abbr.sb-scottish.team.STM": "СТМ",
  "abbr.sb-scottish.team.DDE": "ДДЕ"
}
